<template>
  <div class="v-radio-container">
    <template v-for="(option, idx) in options">
      <input
        :id="`input-${option.key}-${idx}`"
        :key="`input-${option.key}-${idx}`"
        type="radio"
        :name="`input-${option.key}`"
        :value="option.id"
        :checked="isActive(option.id)"
        @input="updateActivePlan"
      >
      <label
        :key="`label-${option.key}-${idx}`"
        :for="`input-${option.key}-${idx}`"
        :class="{
          'v-radio-label': true,
          'v-radio-active': isActive(option.id),
        }"
      >
        <slot
          name="label"
          :props="option"
        >
          {{ option.title }}
        </slot>
      </label>
    </template>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    value: {
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    name: {
      default: 'vue-radio-button',
      type: [String, Number],
    },
  },
  methods: {
    updateActivePlan(e) {
      this.$emit('update', e.target.value)
    },
    isActive(id) {
      return String(this.value) === String(id)
    },
  },
}
</script>

<style scoped>
.v-radio-container input {
  display: none;
}

.v-radio-label {
  cursor: pointer;
}
</style>
